import { BaseEntity, DefaultResponseWithData } from "./system";

export interface IDocumentResponse extends DefaultResponseWithData<IDocument[]> { }

// Mirrors the C# DocumentType enum, which is persisted as ints — only ever append.
export enum DocumentType {
  Vehicle,
  Identity,
  Misc,
  COD,
  CollectionNote,
  Other,
  Yard,
  Part,
  Customer,
  CheckIn,
  // Vehicle photography captured during check-in. Kept apart from Vehicle so it
  // never reaches the eBay listing image picker (GET /vehicle/{id}/images returns
  // Vehicle only) — these record the car as it arrived, not marketing photos.
  CheckInVehicle,
  // Process photography taken during depollution on the yard app. Stored against
  // the vehicle, and kept out of the listing picker and the on-site photo set.
  Depollution,
  // The hazardous waste consignment note photographed on the yard app at check-in
  // (DEFRA waste tracking). Filed against the vehicle's lead; never a listing image.
  WasteConsignmentNote
}

export interface IDocument extends BaseEntity {
  fileName: string | null;
  length: number;
  contents: string;
  contentType: string | null;
  userId: string | null;
  timestamp: string | null;
  thumbnail: string | null;
  type: DocumentType;
  uploadedByCustomer: boolean;
  checkInItemId?: string | null;
  /**
   * The document hangs off a check-in step an administrator marked sensitive. The API blanks
   * `thumbnail` and `fileName` on these for everyone, so render a lock rather than an image, and
   * fetch the contents through `viewSensitiveDocument` (scope + PIN) rather than a plain download.
   */
  isSensitive?: boolean;
  /**
   * An identity document with `Documents:ProtectIdentityDocuments` on. Much weaker than
   * `isSensitive`: only the `thumbnail` is withheld, and the ordinary download still works — so
   * render "click to view" and leave the existing preview and download paths alone. Never set at
   * the same time as `isSensitive`.
   */
  requiresReveal?: boolean;
}